<section class="dashboard">
    <div class="dashboard__title">
        <div class="mb-3">
            <h5 class="mb-2 text-head">Dashboard</h5>
            <p class="text-muted mb-0">
                Find the list of all EHS Data. You can filter, search or download them.
            </p>
        </div>
    </div>
    <div class="d-flex mb-4 mt-1 justify-content-end">
        <a (click)="openMasterPopup()" class="btn btn-outline-primary align-self-center">Upload EHS</a>
    </div>
    <div class="dashboard__content">
        <div class="card mt-1">
            <div class="card-body p-4">
                <app-ag-grid-wrapper #grid
                    [gridConfig]='gridOptions' [rowData]="ehsData" 
                    [columnDefs]="columnDefs" 
                    (rowSelected)="onRowSelect($event)"
                    [frameworkComponents]='frameworkComponents'
                    [context]='context' (gridReady)="onGridReady($event)">
                </app-ag-grid-wrapper>
            </div>
        </div>
    </div>
</section>
